import { toastError, toastSuccess } from '../utils/toastMessage';
import API from '../utils/API';

export const showRewriteRequestPopup = (data) => {
  return {
    type: 'SHOW_REWRITE_REQUEST_POPUP',
    data,
  };
};

export const agreedSuccess = (data) => {
  return {
    type: 'AGREED_SUCCESS',
    data,
  };
};

export const haveMenu = (id, dates, method) => {
  return (dispatch) => {
    API.post(`/course/check`, { userid: id, dates: dates })
      .then((response) => {
        if (response.data.alerts[0] === 'Ok') {
          dispatch(showRewriteRequestPopup(false));
          method();
        } else {
          dispatch(showRewriteRequestPopup(true));
        }
      })
      .catch(() => {
        toastError();
      });
  };
};

export const rewriteRequest = (data, method) => {
  return (dispatch) => {
    dispatch(showRewriteRequestPopup(false));
    if (data) {
      dispatch(agreedSuccess(true));
      setTimeout(() => method(), 0);
      toastSuccess();
    } else {
      dispatch(agreedSuccess(false));
    }
  };
};



// WEBPACK FOOTER //
// ./src/actions/rewriteRequest.js